/*
 * @Auther: qinzhenhao
 * @Date: 2022-12-27 18:33:17
 * @LastEditors: qinzhenhao
 * @LastEditTime: 2023-01-03 15:04:32
 * @Description: 
 */

import { API_URL } from "@/fetch/fetch";
import store from "../store";
import DeviceDetector from "device-detector-js"
const deviceDetector = new DeviceDetector();

// 所有app的name数组
const DOWNLOAD_LIST = ['ydxlm','xmxx','xmgj','xmxxpad','xmzj']
// 依次是小马国炬app，小马鲜鲜app，小马生活app，小马鲜鲜pad，小马之家

// 包名
const PACKAGE_OBJ = {
    xmxx :"com.btob_online_mall_app", //小马鲜鲜APP
    xmxxpad : "com.xmgj.xmxxpad" ,//小马鲜鲜PAD
    ydxlm : "net.guojutech.ydxlm" ,//小马国炬APP
    xmgj : "net.guojutech.app" ,//小马生活APP
    xmzj : "net.guojutech.xmzj", //小马之家APP
}

// 商店地址对象
const STORE_OBJ = {
  xiaomi : "mimarket://details?id=", //小米手机
  huawei : "appmarket://details?id=" ,//华为手机
  oppo : "oppomarket://details?packagename=" ,//oppo手机
  vivo : "vivoMarket://details?id=" ,//vivo手机
}

// 用应用name创建个map
let packageMap = new Map()
DOWNLOAD_LIST.forEach(appname => {
  packageMap.set(appname,PACKAGE_OBJ[appname])
})

// 判断不同机型方法 传入userAgent
function judgeBrand(sUserAgent) {

    let newUserAgent = deviceDetector.parse(sUserAgent);//使用这个插件的原因是oppo也不能识别出来，使用插件就可以识别oppo，但是依旧无法识别vivo
    let brand = newUserAgent.device.brand//手机品牌

    // var isIphone = sUserAgent.match(/iphone/i) == "iphone";
    // var isHuawei = sUserAgent.match(/Huawei/i) == "huawei";
    // var isHonor = sUserAgent.match(/honor/i) == "honor";
    // var isOppo = sUserAgent.match(/OPPO/) == "oppo";
    // var isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
    // var isVivo = sUserAgent.match(/vivo/i) == "vivo";
    // var isXiaomi = sUserAgent.match(/Xiaomi/i) == "xiaomi";
    // var isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix";
    // var isRedmi = sUserAgent.match(/redmi/i) == "redmi";
    // var isSamsung = sUserAgent.match(/sm-/i) == "sm-";

      let isIphone = brand == "Apple";
      let isHuawei = brand == "Huawei";
      let isHonor = brand == "honor";//好像荣耀算在了华为里面，判断成了华为类型
      let isOppo = brand == "OPPO";
      // var isVivo = brand == "vivo"; 
      //vivo目前不太行，userAgent没有vivo相关的信息，暂时先只能判断浏览器为vivo类型才能打开vivo商店下载，使用其他类型浏览器无法打开商店下载
      let isVivo = sUserAgent.match(/vivobrowser/i) == "vivobrowser";
      let isXiaomi = brand== "Xiaomi";
      let isSamsung = brand == "Samsung";


    if (isIphone) {
        return 'iphone';
    } else if (isHuawei || isHonor) {
        return 'huawei';
    } else if (isOppo) {
        return 'oppo';
    } else if (isVivo) {
        return 'vivo';
    } else if (isXiaomi) {
        return 'xiaomi';
    } else if (isSamsung) {
        return 'samsung';
    } else {
        return 'default';
    }
}

// 是小米和华为手机的跳转
function downLoadStore () {
    let name = store.state.downloadName
    let packageName = packageMap.get(name)//获取包名
    let u = navigator.userAgent;
    let judge = judgeBrand(u.toLowerCase()) //判断具体品牌类型
    let url = STORE_OBJ[judge] //商店链接
    window.location.replace(url + packageName)//商店链接 + 包名
}


// 直接下载APP
function downLoadApp () {
  let name = store.state.downloadName //点击下载的软件名
  let downloadType = store.state.type //downloadType：1为手机商店，2为平板应用，3为办公应用
  // 原本代码抽取的逻辑
  if(downloadType === 1){
    var res1;
    var appType = "1";
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //Android
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
    var type = "android";
    if (isiOS) {
      appType = "0";
      type = "ios";
    }

    var res2;
    $.ajax({
      // url:'https://api.guojutech.net/authority-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
      //	url:API_URL+'/filereso-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
      url: API_URL + "/filereso-api/deployApp/getLastVersion?appCode=" + name + "&type=" + type,
      type: "get",
      success: (res) => {
        if (res.success) {
          res1 = res.data.appFileId;
          res2 = res.success;
          // console.log("res.success")
        } else {
          res2 = res.success;
          // alert("下载包不存在")
        }
      //   if (this.isWeiXin()) {
        if (isWeiXin()) {
          $("#JweixinTip").attr("style", "display:block;");
        } else {
          $("#JweixinTip").attr("style", "display:none;");
          if (appType == "0") {
            //如果是IOS 直接跳
            // window.location.href=appIosDownLoadUrl;
            // $('.load').css('display','flex')
            // if(typeof downUrl == Object &&downUrl.packageUrl!=undefined&&downUrl.packageUrl!='')
            if (res2) {
              if (res.data.packageUrl == null || res.data.packageUrl == "") {
                $(".mask").css("display", "flex");
                $(".descript").html("iOS版本审核中，请稍后再尝试下载");
              } else {
                window.location.href = res.data.packageUrl;
              }
              //  =API_URL+ '/authority-api/file/'+res1.data.appFileId
            } else {
              $(".mask").css("display", "flex");
              $(".descript").html("iOS版本审核中，请稍后再尝试下载");
            }
          } else {
            if (res2) {
              $(".load").css({ display: "flex", "align-items": "unset" });
              $(".load p").text("下载请求中，请稍后");
              $(".load p").css({ top: "40%" });
              window.location.href = res1;
              window.event.returnValue = false;
              setTimeout(function() {
                $(".load").css({ display: "none", "align-items": "center" });
                $(".load p").text("正在加载中...");
                $(".load p").css({ top: "0%" });
              }, 3000);
            } else {
              $(".mask").css("display", "flex");
              $(".descript").html("暂无更新");
            }
          }
        }
      },
    });
  }else if(downloadType === 2){
    var res1;
    var appType = "1";
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //Android
    var isiphone = u.indexOf("iPhone") !== -1; //Android
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
    var type = "android";
    // if (isiOS) {
    //     appType = "0";
    //     type = "ios";
    // }
    // if (isiphone) {
    //     $(".mask").css("display", "flex");
    //     $(".descript").html("小马鲜鲜平板应用只支持安卓，请使用安卓系统设备下载");
    //     return;
    // }

    // if (isiOS) {
    //     $(".mask").css("display", "flex");
    //     $(".descript").html("小马鲜鲜平板应用只支持安卓，请使用安卓系统设备下载1");
    // }
    var res2;
    $.ajax({
        // url:'https://api.guojutech.net/authority-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
        //	url:API_URL+'/filereso-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
        url: API_URL + "/filereso-api/deployApp/getLastVersion?appCode=" + name + "&type=" + type,
        type: "get",
        success: (res) => {
            if (res.success) {
                res1 = res.data.appFileId;
                res2 = res.success;
                // console.log("res.success")
            } else {
                res2 = res.success;
                // alert("下载包不存在")
            }
            if (isWeiXin()) {
                if (appType == "0") {
                    $(".mask").css("display", "flex");
                    $(".descript").html("小马鲜鲜平板应用只支持安卓，请使用安卓系统设备下载");
                } else {
                    $("#JweixinTip").attr("style", "display:block;");
                }
            } else {
                $("#JweixinTip").attr("style", "display:none;");
                if (appType == "0") {
                    //如果是IOS 直接跳
                    // window.location.href=appIosDownLoadUrl;
                    // $('.load').css('display','flex')
                    // if(typeof downUrl == Object &&downUrl.packageUrl!=undefined&&downUrl.packageUrl!='')
                    if (res2) {
                        if (res.data.packageUrl == null || res.data.packageUrl == "") {
                            $(".mask").css("display", "flex");
                            $(".descript").html("小马鲜鲜平板应用只支持安卓，请使用安卓系统设备下载");
                        } else {
                            window.location.href = res.data.packageUrl;
                        }
                    } else {
                        $(".mask").css("display", "flex");
                        $(".descript").html("小马鲜鲜平板应用只支持安卓，请使用安卓系统设备下载");
                    }
                } else {
                    if (res2) {
                        $(".load").css({ display: "flex", "align-items": "unset" });
                        $(".load p").text("下载请求中，请稍后");
                        $(".load p").css({ top: "40%" });
                        window.location.href = res1;
                        window.event.returnValue = false;
                        setTimeout(function() {
                            $(".load").css({ display: "none", "align-items": "center" });
                            $(".load p").text("正在加载中...");
                            $(".load p").css({ top: "0%" });
                        }, 3000);
                    } else {
                        $(".mask").css("display", "flex");
                        $(".descript").html("暂无下载包");
                    }
                }
            }
        },
    });
  }else if(downloadType === 3){
          var res1;
          var appType = "1";
          var u = navigator.userAgent;
          var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //Android
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
          var type = "android";
          if (isiOS) {
            appType = "0";
            type = "ios";
          }
    
          var res2;
          $.ajax({
            // url:'https://api.guojutech.net/authority-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
            //	url:API_URL+'/filereso-api/deployApp/getLastVersion?appName=小马鲜鲜&type='+obj.verType,
            url: API_URL + "/filereso-api/deployApp/getLastVersion?appCode=" + name + "&type=" + type,
            type: "get",
            success: (res) => {
              if (res.success) {
                res1 = res.data.appFileId;
                res2 = res.success;
                // console.log("res.success")
              } else {
                res2 = res.success;
                // alert("下载包不存在")
              }
              if (isWeiXin()) {
                $("#JweixinTip").attr("style", "display:block;");
              } else {
                $("#JweixinTip").attr("style", "display:none;");
                if (appType == "0") {
                  //如果是IOS 直接跳
                  // window.location.href=appIosDownLoadUrl;
                  // $('.load').css('display','flex')
                  // if(typeof downUrl == Object &&downUrl.packageUrl!=undefined&&downUrl.packageUrl!='')
                  if (res2) {
                    if (res.data.packageUrl == null || res.data.packageUrl == "") {
                      $(".mask").css("display", "flex");
                      $(".descript").html("iOS版本审核中，请稍后再尝试下载");
                    } else {
                      window.location.href = res.data.packageUrl;
                    }
                    //  =API_URL+ '/authority-api/file/'+res1.data.appFileId
                  } else {
                    $(".mask").css("display", "flex");
                    $(".descript").html("iOS版本审核中，请稍后再尝试下载");
                  }
                } else {
                  if (res2) {
                    $(".load").css({ display: "flex", "align-items": "unset" });
                    $(".load p").text("下载请求中，请稍后");
                    $(".load p").css({ top: "40%" });
                    window.location.href = res1;
                    window.event.returnValue = false;
                    setTimeout(function() {
                      $(".load").css({ display: "none", "align-items": "center" });
                      $(".load p").text("正在加载中...");
                      $(".load p").css({ top: "0%" });
                    }, 3000);
                  } else {
                    $(".mask").css("display", "flex");
                    $(".descript").html("暂无更新");
                  }
                }
              }
            },
          });
  }

}


function isWeiXin(){
    //是否是微信打开，并且提示引导
    var ua = window.navigator.userAgent.toLowerCase();
    //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
    $("#JweixinTip").attr("style", "display:none;");
    return true;
    } else {
    $("#JweixinTip").attr("style", "display:none;");
    return false;
    }
}

// 返回true或者false , 判断软件是否在该手机品牌应用商店上线
function judgeFlag(){
    var u = navigator.userAgent;
    let judge = judgeBrand(u.toLowerCase()) //判断据体品牌类型
    let judgeArr = ['huawei','xiaomi','oppo','vivo'] //已上架的品牌数组
    if(judgeArr.indexOf(judge) !== -1){
        return true
    }else{
        return false
    }
}


export default {
    judgeBrand,
    judgeFlag,
    downLoadStore,
    downLoadApp
}